<template>
  <el-dialog
    :visible.sync="showDialog"
    :before-close="handleClose"
    :width="modalWidth"
    top="20vh"
    append-to-body
    :custom-class="isHoldingsTransfer ? 'custom-dialog-class' : ''"
  >
    <div class="w-full text-root-2 flex justify-center items-center -mt-10">
      <div class="md:px-4 pt-6">
        <span
          style="word-break: normal"
          class="flex justify-center font-semibold text-2xl text-center"
          >2-Factor Authentication
        </span>

        <div
          style="word-break: normal"
          class="flex justify-center text-fg-default mt-1 mb-4 text-center text-xs font-light lg:w-3/5 mx-auto lg:text-sm"
        >
          Enter the 6-digit code you see in the authenticator app
        </div>
        <span
          class="text-fg-default font-semibold flex justify-center text-sm mt-8 mb-3"
        >
          Enter 6 digit code</span
        >
        <div class="mx-4">
          <el-form
            label-position="top"
            :model="verifyAuthForm"
            ref="verifyAuthForm"
            label-width="80px"
            size="normal"
            @submit.prevent
            @keyup.enter.native="validateForm('verifyAuthForm')"
          >
            <el-form-item prop="code" class="mb-4 w-full">
              <div class="flex items-center justify-center gap-x-1 w-full">
                <input
                  v-for="(n, index) in codeLength"
                  :key="index"
                  :ref="'input' + (index + 1)"
                  pattern="\d*"
                  placeholder="*"
                  type="text"
                  :id="'input_' + (index + 1)"
                  maxlength="1"
                  v-model="code[index + 1]"
                  @input="handleInput"
                  @keypress="isNumber"
                  @keydown.delete="handleDelete"
                  @paste="onPaste"
                  :disabled="isLoading"
                  :autofocus="index === 0"
                  class="w-full shadow-sm rounded-lg text-center px-1.5 transition-all duration-300 hover:border-primary focus:border-primary active:border-primary border"
                />
              </div>
            </el-form-item>
            <div class="mt-6 mb-4">
              <el-button
                class="w-full cursor-pointer border-none bg-primary text-white rounded-lg p-3.5 text-base font-normal flex items-center justify-center"
                @click="validateForm('verifyAuthForm')"
                :disabled="verifyAuthForm.code.length !== 6"
                :loading="isLoading"
              >
                {{ isLoading ? 'Verifying...' : 'Next' }}
              </el-button>
            </div>
            <p
              class="flex justify-center font-normal text-sm md:text-sm mt-10 cursor-pointer"
              @click="handleClose"
            >
              Cancel
            </p>
          </el-form>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
import { TWO_FA_KEYS_ALLOWED } from '@/utils/constants'
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    authState: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      breakpoints,
      isLoading: false,
      codeLength: 6,
      keysAllowed: TWO_FA_KEYS_ALLOWED,
      code: {
        1: '',
        2: '',
        3: '',
        4: '',
        5: '',
        6: ''
      },
      dataFromPaste: [],
      test: '',
      verifyAuthForm: {
        code: ''
      },
      isPaste: false
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '33%' : breakpoints.mdAndUp ? '70%' : '90%'
    },
    isHoldingsTransfer () {
      return this.authState === 'holdingsTransfer'
    }
  },
  methods: {
    handleClose () {
      this.isLoading = false
      this.resetForm('verifyAuthForm')
      this.$emit('closeDialog')
    },
    validateForm (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.isLoading = true
          if (this.authState === 'swapBeneficiaryFormState') {
            this.$emit('createSwapBeneficiary', this.verifyAuthForm)
          } else if (this.authState === 'deleteWalletAddress') {
            this.$emit('deleteWalletAddress', this.verifyAuthForm)
          } else if (this.authState === 'terminateBulkPayout') {
            this.$emit('terminateBulkPayout', this.verifyAuthForm)
          } else if (this.authState === 'approveBulkPayout') {
            this.$emit('approveBulkPayout', this.verifyAuthForm)
          } else if (this.authState === 'confirmBulkPayout') {
            this.$emit('confirmBulkPayout', this.verifyAuthForm)
          } else if (this.authState === 'createWithdrawal') {
            this.$emit('verifiedUser', { ...this.verifyAuthForm })
          } else if (this.authState === 'deleteWithdrawalMethod') {
            this.$emit('deleteWithdrawalMethod', { ...this.verifyAuthForm })
          } else if (this.authState === 'initiateWithdrawal') {
            this.$emit('initiateWithdrawalRequest', { ...this.verifyAuthForm })
          } else if (this.authState === 'inviteUser') {
            this.$emit('verifiedUser', { ...this.verifyAuthForm })
          } else if (this.authState === 'reassignUser') {
            this.$emit('confirmedUpdateRole', { ...this.verifyAuthForm })
          } else if (this.authState === 'initiateSwapDeposit') {
            this.$emit('initiateSwapDeposit', this.verifyAuthForm.code)
          } else if (this.authState === 'processSwapApproval') {
            this.$emit('processSwapApproval', this.verifyAuthForm.code)
          } else if (this.authState === 'initiateWithdrawal') {
            this.$emit('initiateWithdrawalRequest', { ...this.verifyAuthForm })
          } else if (this.authState === 'createWithdrawalMethod') {
            this.$emit('createWithdrawalMethod', { ...this.verifyAuthForm })
          } else if (this.authState === 'retryBulkPayout') {
            this.$emit('retryBulkPayout', this.verifyAuthForm)
          } else if (this.authState === 'holdingsTransfer') {
            this.$emit('initiateHoldingsTransfer', { ...this.verifyAuthForm })
          } else if (
            this.authState === 'approveWithdrawal' ||
            this.authState === 'cancelWithdrawal'
          ) {
            this.$emit('approveCancelWithrawalRequest', {
              ...this.verifyAuthForm
            })
          } else if (this.authState === 'processTransfer') {
            this.$emit('processTransferRequest', { ...this.verifyAuthForm })
          } else if (this.authState === 'generateKeyState') {
            this.$emit('generateApiKeys', { ...this.verifyAuthForm })
            this.$emit('closeDialog')
          } else if (this.authState === 'generateTransactionReport') {
            this.$emit('generateReport', { ...this.verifyAuthForm })
          } else if (this.authState === 'whitelistIPAddress') {
            this.$emit('whitelistIPAddress', { ...this.verifyAuthForm })
          } else if (this.authState === 'deleteWhitelistedIP') {
            this.$emit('deleteWhitelistedIP', { ...this.verifyAuthForm })
          }
        } else {
          this.$notify.error({
            title: 'Invalid Pin',
            message: 'Please enter a valid pin',
            position: 'top-right'
          })
        }
      })
    },
    resetForm (form) {
      this.$refs[form].resetFields()
    },
    handleDelete (event) {
      const value = event.target.value
      const currentActiveElement = event.target
      if (!value) {
        currentActiveElement.previousElementSibling.focus()
      }
    },
    isNumber (event) {
      const keyPressed = event.key
      if (!this.keysAllowed.includes(keyPressed)) {
        event.preventDefault()
      }
    },
    onPaste (event) {
      this.dataFromPaste = event.clipboardData?.getData('text').trim().split('')
      if (this.dataFromPaste) {
        for (const num of this.dataFromPaste) {
          if (!this.keysAllowed.includes(num)) event.preventDefault()
        }
      }
    },
    handleInput (event) {
      const inputType = event.inputType
      let currentActiveElement = event.target
      if (inputType === 'insertText') {
        this.isPaste = false
        if (currentActiveElement.nextElementSibling) {
          currentActiveElement.nextElementSibling.focus()
        } else {
          // starts from the beginning
          currentActiveElement = document.querySelector('#input_1')
          currentActiveElement.focus()
        }
      }
      if (inputType === 'insertFromPaste' && this.dataFromPaste) {
        this.isPaste = true
        for (const num of this.dataFromPaste) {
          const id = parseInt(currentActiveElement.id.split('_')[1])
          currentActiveElement.value = num
          this.code[id] = num
          if (currentActiveElement.nextElementSibling) {
            currentActiveElement = currentActiveElement.nextElementSibling
            currentActiveElement.nextElementSibling.focus()
          }
        }
      }
      this.extractCode()
    },
    extractCode () {
      let result = ''
      Object.values(this.code).forEach((val) => {
        result += val
      })
      this.verifyAuthForm.code = result
    }
  },
  watch: {
    'verifyAuthForm.code': function (newValue) {
      if (newValue.length !== 6) {
        const result = newValue.replace(/\D/g, '').replace(/[^0-9]/g, '')
        this.$nextTick(() => {
          this.verifyAuthForm.code = `${result}`
        })
      } else {
        this.validateForm('verifyAuthForm')
      }
    },
    isPaste: function (newValue) {
      if (newValue) {
        this.code[6] = this.dataFromPaste[5]
        this.extractCode()
      }
    },
    deep: true
  }
}
</script>

<style scoped>
>>> .el-dialog__body {
  padding: 30px 15px;
}
>>> .el-icon-close:before {
  padding: 25px;
  opacity: 0.9;
  color: #c7c8d2;
}
>>> .el-button.is-disabled {
  background: var(--color-primary);
  color: white;
}
input:focus,
input:active {
  color: var(--color-primary);
  outline: 1px solid var(--color-primary) !important;
  border-color: var(--color-primary);
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='text'] {
  -moz-appearance: textfield;
  font-size: 1.5rem;
  text-align: center;
  padding: 0.5rem 1.25rem;
}
input::placeholder {
  border-color: #c7c8d2;
}
>>> .el-dialog {
  border-radius: 0.5rem !important;
}
@media screen and (max-width: 768px) {
  input[type='text'] {
    padding: 0.15rem 0.525rem;
  }
}
@media screen and (min-width: 1280px) {
  >>> .custom-dialog-class {
    margin-left: 39.5vw;
  }
}
</style>
